import React from 'react';

/**
 * Indicates when an ajax call is being waited on and if so, will show a spinning cog from font-awesome
 *
 * @returns {*}
 * @constructor
 */
const Loader = () => {
	return (
		<div className={'text-center loader'}>
			<i className={'far fa-cog fa-spin'}>
			</i>
		</div>
	);
};

export default Loader;
